import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class Widgets {
  constructor() {
    _defineProperty(this, "widgets", []);
  }
  add(widget) {
    this.widgets.push(widget);
    return this;
  }
  extend(app, extension) {
    this.widgets.forEach(widget => {
      app.widgets.add(widget, extension);
    });
  }
}
flarum.reg.add('fof-forum-widgets-core', 'common/extend/Widgets', Widgets);